import { useState } from 'react'
import { api, errorMessage } from '../api.js'
import { Alert, Button, Field, Input } from '../components/ui.js'

export function Login({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api.auth.login.mutate({ email, password })
      onDone()
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="grid min-h-full place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">
          Plano de controle
        </p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight">Via 360 Graus</h1>
        <p className="mt-2 text-sm text-ink-2">
          Frota, produtos, segredos e acessos — em um lugar so.
        </p>

        <div className="mt-8 space-y-4 rounded border border-line bg-panel p-6 shadow-sm">
          <Field label="E-mail">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </Field>
          <Field label="Senha">
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>

          {error && <Alert>{error}</Alert>}

          <Button type="submit" variant="primary" disabled={busy}>
            {busy ? 'Entrando...' : 'Entrar'}
          </Button>

          <p className="pt-1 text-xs text-ink-3">
            Nao existe cadastro aberto. Contas nascem por convite de um owner.
          </p>
        </div>
      </form>
    </div>
  )
}
